module.exports = __webpack_public_path__ + "img/w3_cloud_grey.4ffb0de0.png";